import React from 'react'
import Index from './Index'

const OptionsIndex = () => {
  return (
    <Index />
  )
}

export default OptionsIndex